import { normalizeMultilingualValue } from "@/utils/multilingual";

const RELATION_FIELDS = [
  "licenses",
  "researchers",
  "publications",
  "projects",
  "research_areas",
  "softwares"
];

export function createDefaultDataset() {
  return {
    id: null,
    slug: "",
    title: "",
    short_description: normalizeMultilingualValue(""),
    description: normalizeMultilingualValue(""),
    publication_date: "",
    access_type: "open",
    access_instructions: "",
    licenses: [],
    doi: "",
    preferred_citation: "",
    keywords: [""],
    website_url: "",
    download_url: "",
    hugging_face_url: "",
    responsible_person: null,
    researchers: [],
    publications: [],
    projects: [],
    research_areas: [],
    softwares: []
  };
}

function relationIds(items) {
  if (!Array.isArray(items)) {
    return [];
  }
  return Array.from(new Set(items.map(item => {
    if (item && typeof item === "object") {
      return item.id !== undefined && item.id !== null ? item.id : item.value;
    }
    return item;
  }).filter(value => value !== undefined && value !== null && value !== "")));
}

export function normalizeDataset(payload = {}) {
  const normalized = {
    ...createDefaultDataset(),
    ...payload,
    short_description: normalizeMultilingualValue(payload.short_description || ""),
    description: normalizeMultilingualValue(payload.description || ""),
    publication_date: payload.publication_date || "",
    preferred_citation: payload.preferred_citation || "",
    keywords: Array.isArray(payload.keywords) && payload.keywords.length
      ? payload.keywords
      : [""],
    responsible_person: payload.responsible_person || null
  };
  RELATION_FIELDS.forEach(field => {
    normalized[field] = relationIds(payload[field]);
  });
  return normalized;
}

export function serializeDataset(dataset) {
  const payload = {
    title: dataset.title || "",
    short_description: normalizeMultilingualValue(dataset.short_description),
    description: normalizeMultilingualValue(dataset.description),
    publication_date: dataset.publication_date || null,
    access_type: dataset.access_type || "open",
    access_instructions: dataset.access_instructions || "",
    doi: dataset.doi || "",
    preferred_citation: dataset.preferred_citation || "",
    keywords: (dataset.keywords || []).filter(value => value && value.trim()),
    website_url: dataset.website_url || "",
    download_url: dataset.download_url || "",
    hugging_face_url: dataset.hugging_face_url || "",
    responsible_person: relationIds([dataset.responsible_person])[0] || null
  };
  RELATION_FIELDS.forEach(field => {
    payload[field] = relationIds(dataset[field]);
  });
  return payload;
}
